import React from "react";
import {
  Project,
} from "src/lib/graphql/types";
import StarOutlineIcon from "../icons/StarOutlineIcon";

type StarBadgeProps = {
  interactive?: boolean;
  project: Pick<Project, "pathWithNamespace" | "starCount">;
};

export const StarBadge: React.FC<StarBadgeProps> = ({
  project,
}) => {
  const { starCount } = project;

  return (
    <div className="star-badge badge">
      <StarOutlineIcon />
      <span>{starCount}</span>
    </div>
  );
};

export default StarBadge;
